export default __webpack_public_path__ + "static/media/category_15.7b76d8ce.png";